export const ChatMessageSenderType = Object.freeze({
  astrologer: "1",
  customer: "2",
});